<template>
  <div class="row pages-containter">
    <div class="md-3">
      <div class="mb-1">
        <div v-if="pages.length > 0">
          <div v-for="(page, index) in pages" :key="index" :title="page.name">
            <EditPageDetails :page="page" :index="index" @delete="deletePage" @preview="previewPage" @reload="init"></EditPageDetails>
          </div>
        </div>
        <div v-else class="text-center m-1">
          <p>No pages created yet.</p>
        </div>
      </div>
      <div class="text-right pr-1">
        <button class="btn primary" @click="addPage()">Add Page</button>
      </div>
    </div>
    <div class="md-9">
      <PagePreview :page="selectedPage" v-if="selectedPage">
      </PagePreview>
    </div>
  </div>
</template>

<script>
import TextComponent from '../base.component/TextComponent.vue';
import FileUploadComponent from '@/components/base.component/FileUploadComponent.vue';
import ConfirmationComponent from '@/components/base.component/ConfirmationComponent.vue';
import EdsAccordion from '@/components/base.component/EdsAccordion.vue';
import EdsAccordionItem from '@/components/base.component/EdsAccordionItem.vue';
import PageApiService from '@/services/api/pageApiService';
import EditPageDetails from '@/components/complex.component/EditPageDetails.vue';
import PagePreview from '@/components/complex.component/PagePreview.vue';

const EMPTY_PAGE = { id: null, name: '', shortName: '', isPublished: false, sections: [{}] };

export default {
  components: {
    TextComponent,
    FileUploadComponent,
    ConfirmationComponent,
    EdsAccordion,
    EdsAccordionItem,
    EditPageDetails,
    PagePreview
  },

  data() {
    return {
      pages: [],
      selectedPage: null
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    addPage() {
      this.pages.push({...EMPTY_PAGE});
    },
    async deletePage(index) {
      await PageApiService.delete(this.pages[index].id);
      this.pages.splice(index, 1);
    },
    previewPage(page) {
      this.selectedPage = page;
    },
    async init() {
      this.pages = await PageApiService.getAll();
      this.selectedPage = this.pages.length > 0 ? this.pages[0] : null;
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/common.less';

.pages-containter {
  > div {
    height: calc(100vh - 48px);
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>
